import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Loader2, History } from "lucide-react";

export default function ApprovalHistory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/approval-history").then((res) => setItems(res.data.requests || [])).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-court-orange" /></div>;

  return (
    <div className="max-w-6xl mx-auto px-4 md:px-8 py-6 md:py-10 space-y-6" data-testid="approval-history-page">
      <h1 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight flex items-center gap-3"><History className="w-8 h-8 text-court-orange" />Approval History</h1>
      <div className="grid grid-cols-1 gap-3">
        {items.map((item) => (
          <Card key={item.request_id} data-testid={`approval-history-${item.request_id}`}>
            <CardHeader><CardTitle className="font-heading text-lg flex items-center justify-between"><span>{item.title}</span><Badge variant="outline">{item.status}</Badge></CardTitle></CardHeader>
            <CardContent>
              <p className="text-sm text-zinc-600">{item.module} · {item.target_type} · {item.target_id || 'pending target'}</p>
              <p className="text-sm text-zinc-600">Approvals: {(item.approvals || []).length} / {item.approval_required_count}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}